import { _ } from '@icc/shared/helpers';

export const enum ComplaintsDocumentType {
    Complaint = 10,
    Service = 11,
}

export const ComplaintsDocumentTypes = {
    complaint: ComplaintsDocumentType.Complaint,
    service: ComplaintsDocumentType.Service
};
export const ComplaintsDocumentTypesIds = [
    ComplaintsDocumentType.Complaint,
    ComplaintsDocumentType.Service
];
export const ComplaintsDocumentTypeDict = {
    [ComplaintsDocumentType.Complaint]: _('COMPLAINT|Zgłoszenie reklamacyjne'),
    [ComplaintsDocumentType.Service]: _('COMPLAINT|Serwis poza-reklamacyjny'),
};
